// utils/languageDetection.js

export const SUPPORTED_LANGS = ['ru', 'uk', 'en', 'de'];

const normalizeLang = (lang) => {
  if (!lang) return null;
  const l = lang.slice(0, 2).toLowerCase();
  return SUPPORTED_LANGS.includes(l) ? l : null;
};

export const detectDeviceLanguage = (isAndroidApp, deviceLanguage) => {
  let detected = null;

  // 1️⃣ Android App (самый надёжный)
  if (isAndroidApp && deviceLanguage) {
    detected = normalizeLang(deviceLanguage);
    if (detected) {
      console.log('[LangDetect] Android deviceLanguage:', detected);
      return detected;
    }
  }

  // 2️⃣ Telegram WebApp
  try {
    const tgLang = window?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
    detected = normalizeLang(tgLang);
    if (detected) {
      console.log('[LangDetect] Telegram language:', detected);
      return detected;
    }
  } catch (e) {}

  // 3️⃣ Browser language (fallback)
  const browserLangs = [];

  if (Array.isArray(navigator.languages)) {
    browserLangs.push(...navigator.languages);
  }

  if (navigator.language) {
    browserLangs.push(navigator.language);
  }

  for (const lang of browserLangs) {
    detected = normalizeLang(lang);
    if (detected) {
      console.log('[LangDetect] Browser language:', detected);
      return detected;
    }
  }

  // 4️⃣ Default
  console.log('[LangDetect] Fallback to ru');
  return 'ru';
};